import { render, staticRenderFns } from "./gkfooter.vue?vue&type=template&id=594be5ea&scoped=true&"
import script from "./gkfooter.vue?vue&type=script&lang=js&"
export * from "./gkfooter.vue?vue&type=script&lang=js&"
import style0 from "./gkfooter.vue?vue&type=style&index=0&id=594be5ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594be5ea",
  null
  
)

export default component.exports